import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { useResponsive } from '../../../../utils/hooks/useResponsive';
import Stack from '../../../ui/layout/Stack';
import RadioTabGroup from '../../../ui/atoms/RadioTab/RadioTabGroup';
import RadioTab from '../../../ui/atoms/RadioTab/RadioTab';
import { ReactComponent as GreenArrowIcon } from '@public/icons/green-arrow.svg';
import { DeprecatedText } from '../../../ui/atoms/DeprecatedText';
import Cluster from '../../../ui/layout/Cluster';
import { PRICING_CURRENCY } from '../../../../utils/pricing';
import PricingContext from './PricingContext';
import styled from 'styled-components';

const MONTHLY = 'monthly';
const YEARLY = 'yearly';

const Periodicity = () => {
    const { isDesktop } = useResponsive();
    const { isYearlyPeriodicitySelected, setYearlyPeriodicitySelected } =
        useContext(PricingContext);

    return (
        <Stack $align="center" $gap={isDesktop ? null : '0.5rem'}>
            <FormattedMessage defaultMessage="Périodicité">
                {(label) => (
                    <RadioTabGroup
                        name="periodicity"
                        aria-label={label.join('')}
                        value={isYearlyPeriodicitySelected ? YEARLY : MONTHLY}
                        onChange={(selectedPeriodicity) =>
                            setYearlyPeriodicitySelected(selectedPeriodicity === YEARLY)
                        }
                    >
                        <RadioTab value={MONTHLY}>
                            <FormattedMessage defaultMessage="Mensuel" />
                        </RadioTab>
                        <RadioTab value={YEARLY}>
                            <FormattedMessage defaultMessage="Annuel" />
                        </RadioTab>
                        {isDesktop && (
                            <GreenArrowIcon
                                css={`
                                    height: 1rem;
                                    width: 1.125rem;
                                    position: absolute;
                                    left: calc(100% + 0.25rem);
                                    bottom: 0;
                                `}
                            />
                        )}
                    </RadioTabGroup>
                )}
            </FormattedMessage>
            <DeprecatedText
                color="--success"
                weight="semibold"
                css={`
                    position: ${isDesktop ? 'relative' : null};
                    left: calc(100% + 0.75rem);
                    line-height: 1.5em;
                    align-self: flex-start;
                `}
            >
                <FormattedMessage defaultMessage="2 mois offerts en annuel" />
            </DeprecatedText>
        </Stack>
    );
};

const Currency = () => {
    const { selectedCurrency, setSelectedCurrency } = useContext(PricingContext);

    return (
        <FormattedMessage defaultMessage="Devise">
            {(label) => (
                <RadioTabGroup
                    name="currency"
                    aria-label={label.join('')}
                    value={selectedCurrency}
                    onChange={setSelectedCurrency}
                >
                    <RadioTab value={PRICING_CURRENCY.EUR}>€</RadioTab>
                    <RadioTab value={PRICING_CURRENCY.USD}>$</RadioTab>
                    <RadioTab value={PRICING_CURRENCY.GBP}>£</RadioTab>
                </RadioTabGroup>
            )}
        </FormattedMessage>
    );
};

const PricingControls = ({ displayCurrency }) => {
    const { isDesktop } = useResponsive();

    return (
        <Cluster $justify={displayCurrency ? 'space-between' : 'center'} $gap="1rem">
            {/* Placeholder used to center Periodicity. Should match Currency size. */}
            {displayCurrency && isDesktop && <Placeholder />}
            <Periodicity />
            {displayCurrency && <Currency />}
        </Cluster>
    );
};

const Placeholder = styled.div`
    width: 6.375rem;
`;

export default PricingControls;
